module.exports = __webpack_public_path__ + "img/header_logo_original.ad9e5cc.svg";